import React from 'react';
import './App.css';
import Home from './Components/Home/Home/Home';

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
